import type { IInitConfig } from '@flagsmith/flagsmith';
import { DEFAULT_FLAGS, type FeatureFlagName } from './feature-flags.constants';

const MISSING_ENVIRONMENT_ID = 'missing-flagsmith-environment-key';
const MISSING_KEY_MESSAGE =
  'VITE_APP_FLAGSMITH_ENVIRONMENT_KEY is not configured; menu flags default to off.';
const UNAVAILABLE_MESSAGE =
  'Flagsmith unavailable; using cached or default menu flags.';

export type FeatureFlagErrorReporter = (message: string, error?: Error) => void;

const reportToConsole: FeatureFlagErrorReporter = (message, error) => {
  if (error) {
    console.error(message, error);
    return;
  }
  console.error(message);
};

export const createFeatureFlagsOptions = (
  environmentID: string | undefined,
  reportError: FeatureFlagErrorReporter = reportToConsole,
): IInitConfig<FeatureFlagName> => {
  const isConfigured = Boolean(environmentID);
  if (!isConfigured) reportError(MISSING_KEY_MESSAGE);

  return {
    environmentID: environmentID || MISSING_ENVIRONMENT_ID,
    cacheFlags: isConfigured,
    defaultFlags: DEFAULT_FLAGS,
    enableAnalytics: false,
    realtime: false,
    preventFetch: !isConfigured,
    onError: (error) => reportError(UNAVAILABLE_MESSAGE, error),
  };
};
